<span>
  {{ ("STAFF_ACCOUNT" | translate) + " " }}

  <a [routerLink]="['/staff', $safeNavigationMigration(log?.details?.targetId)]" (click)="closeDialog.emit()">
    {{ $safeNavigationMigration(log?.details?.targetName) | identityFormat : $safeNavigationMigration(log?.details?.targetId) }}
  </a>

  {{ " " + ("WAS_MODIFIED_BY" | translate) + " " }}

  @if (!log?.staffId && log?.staffName === 'Everon Admin') {
    <strong>
      Everon Admin
    </strong>
  } @else {
    <a [routerLink]="['/staff', $safeNavigationMigration(log?.staffId)]" (click)="closeDialog.emit()">{{ $safeNavigationMigration(log?.staffName) | identityFormat : $safeNavigationMigration(log?.staffId) }}</a>
  }

</span>
<p class="mt-1">{{ $safeNavigationMigration(log?.timestamp) | moment : "l LTS" }}</p>

<hr />

@if (!(accountChanges | propsFalsy : ['roleLevel', 'lockRights'])) {
  <div class="pb-3">
    <span class="subtitle"><i class="fa-solid fa-shield-halved fa-lg pr-2"></i>{{ "MODIFIED_PERMISSIONS" | translate | uppercase }}</span>
    <div class="container modified-permissions-box" [ngStyle]="log | boxLayoutStyle">
      @if (accountChanges?.roleLevel) {
        <span class="item-title">{{ "ACCESS_RIGHTS" | translate }}:</span>
        <div class="item-pair-value">
          <span class="negative-highlight line-through">{{ $safeNavigationMigration(accountChanges?.roleLevel?.oldValue) | userRole }}</span>
          <i class="fa-light fa-arrow-right-long fa-lg"></i>
          <span class="positive-highlight">{{ $safeNavigationMigration(accountChanges?.roleLevel?.newValue) | userRole }}</span>
        </div>
      }
      @if (accountChanges?.lockRights) {
        <span class="item-title">{{ "LOCK_RIGHTS" | translate }}:</span>
        <div class="item-value">
          @if (lockRightsRemoved.length > 0) {
            <span class="negative-highlight line-through">{{ lockRightsRemoved | lockRights }}</span>
          }
          @if (lockRightsAdded.length > 0) {
            <span class="positive-highlight" [class.mt-2]="lockRightsRemoved.length > 0">{{ lockRightsAdded | lockRights }}</span>
          }
          @if (lockRightsRemoved.length === 0 && lockRightsAdded.length === 0) {
            <span>{{ 'NONE' | translate }}</span>
          }
        </div>
      }
    </div>
  </div>
}

@if (!(accountChanges | allPropsFalsy : ['roleLevel', 'lockRights'])) {
  <span class="subtitle">
    {{ (!(accountChanges | propsFalsy : ['roleLevel', 'lockRights']) ? "OTHER_MODIFICATIONS" : "MODIFICATIONS") | translate | uppercase }}
  </span>
  <div class="container">
    <!-- First name -->
    @if (visibleFields | includes : 'firstName') {
      <span class="item-title">{{ "FIRST_NAME" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ accountChanges?.firstName?.oldValue || "NONE" | translate }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ accountChanges?.firstName?.newValue || "NONE" | translate }}
        </span>
      </div>
    }
    <!-- Family name -->
    @if (visibleFields | includes : 'familyName') {
      <span class="item-title">{{ "LAST_NAME" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ accountChanges?.familyName?.oldValue || "NONE" | translate }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ accountChanges?.familyName?.newValue || "NONE" | translate }}
        </span>
      </div>
    }
    <!-- Username -->
    @if (visibleFields | includes : 'username') {
      <span class="item-title">{{ "USERNAME" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ accountChanges?.username?.oldValue || "NONE" | translate }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ accountChanges?.username?.newValue || "NONE" | translate }}
        </span>
      </div>
    }
    <!-- Location -->
    @if (visibleFields | includes : 'locationId') {
      <span class="item-title">{{ "LOCATION" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ accountChanges?.locationId?.oldValue || "NONE" | translate }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ accountChanges?.locationId?.newValue || "NONE" | translate }}
        </span>
      </div>
    }
    <!-- Location access -->
    @if (visibleFields | some : 'addedLocationRights' : 'removedLocationRights') {
      <span class="item-title">{{ "LOCATION_ACCESS" | translate }}:</span>
      @if (visibleFields | includes : 'addedLocationRights') {
        <span id="added-location-rights" class="item-value d-flex align-items-center">
          {{ "ADDED_TO" | translate }}
          <span class="positive-highlight ml-2">
            {{ $safeNavigationMigration(accountChanges?.addedLocationRights) | join : ', ' || "NONE" | translate }}
          </span>
        </span>
      }
      @if (visibleFields | includes : 'addedLocationRights' : 'removedLocationRights') {
        <div></div>
      }
      @if (visibleFields | includes : 'removedLocationRights') {
        <span id="removed-location-rights" class="item-value d-flex align-items-baseline">
          {{ "REMOVED_FROM" | translate }}
          <span class="negative-highlight line-through ml-2">
            {{ $safeNavigationMigration(accountChanges?.removedLocationRights) | join : ', ' || "NONE" | translate }}
          </span>
        </span>
      }
    }
    <!-- Receiver teams -->
    @if (visibleFields | some : 'addedReceiverTeams' : 'removedReceiverTeams') {
      <span class="item-title">{{ "RECEIVER_GROUPS" | translate }}:</span>
      @if (visibleFields | includes : 'addedReceiverTeams') {
        <span id="added-user-groups" class="item-value d-flex align-items-center">
          {{ "ADDED_TO" | translate }}
          <span class="positive-highlight ml-2">
            {{ $safeNavigationMigration(accountChanges?.addedReceiverTeams) | join : ', ' || "NONE" | translate }}
          </span>
        </span>
      }
      @if (visibleFields | includes : 'addedReceiverTeams' : 'removedReceiverTeams') {
        <div></div>
      }
      @if (visibleFields | includes : 'removedReceiverTeams') {
        <span id="removed-user-groups" class="item-value d-flex align-items-baseline">
          {{ "REMOVED_FROM" | translate }}
          <span class="negative-highlight line-through ml-2">
            {{ $safeNavigationMigration(accountChanges?.removedReceiverTeams) | join : ', ' || "NONE" | translate }}
          </span>
        </span>
      }
    }
    <!-- Alarm routes -->
    @if (visibleFields | some : 'addedAlarmRoutes' : 'removedAlarmRoutes') {
      <span class="item-title">{{ "ALARM_ROUTES" | translate }}:</span>
      @if (visibleFields | includes : 'addedAlarmRoutes') {
        <span id="added-alarm-routes" class="item-value d-flex align-items-center">
          {{ "ADDED_TO" | translate }}
          <span class="positive-highlight ml-2">
            {{ $safeNavigationMigration(accountChanges?.addedAlarmRoutes) | join : ', ' || "NONE" | translate }}
          </span>
        </span>
      }
      @if (visibleFields | includes : 'addedAlarmRoutes' : 'removedAlarmRoutes') {
        <div></div>
      }
      @if (visibleFields | includes : 'removedAlarmRoutes') {
        <span id="removed-alarm-routes" class="item-value d-flex align-items-baseline">
          {{ "REMOVED_FROM" | translate }}
          <span class="negative-highlight line-through ml-2">
            {{ $safeNavigationMigration(accountChanges?.removedAlarmRoutes) | join : ', ' || "NONE" | translate }}
          </span>
        </span>
      }
    }
    <!-- GSM number -->
    @if (visibleFields | includes : 'gsmNumber') {
      <span class="item-title">{{ "GSM_NUMBER" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ accountChanges?.gsmNumber?.oldValue || "NONE" | translate }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ accountChanges?.gsmNumber?.newValue || "NONE" | translate }}
        </span>
      </div>
    }
    <!-- Email -->
    @if (visibleFields | includes : 'email') {
      <span class="item-title">{{ "EMAIL" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ accountChanges?.email?.oldValue || "NONE" | translate }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ accountChanges?.email?.newValue || "NONE" | translate }}
        </span>
      </div>
    }
    <!-- Language -->
    @if (visibleFields | includes : 'language') {
      <span class="item-title">{{ "LANGUAGE" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ accountChanges?.language?.oldValue || "NONE" | translate }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ accountChanges?.language?.newValue || "NONE" | translate }}
        </span>
      </div>
    }
    <!-- Identity user -->
    @if (visibleFields | includes : 'identityUser') {
      <span class="item-title">{{ "STRONG_AUTHENTICATION_USER" | translate }}:</span>
      <div class="item-pair-value">
        <span class="negative-highlight line-through">
          {{ accountChanges?.identityUser?.oldValue || "NONE" | translate }}
        </span>
        <i class="fa-light fa-arrow-right-long fa-lg"></i>
        <span class="positive-highlight">
          {{ accountChanges?.identityUser?.newValue || "NONE" | translate }}
        </span>
      </div>
    }
    <!-- Temporary Code Access -->
    @if (visibleFields | some : 'temporaryCodeAccessEnabled' : 'temporaryCodeAccessDisabled') {
      <span class="item-title">{{ "TEMPORARY_CODE_GENERATION" | translate }}:</span>
      <div class="item-value">
        @if (visibleFields | includes : 'temporaryCodeAccessEnabled') {
          <span id="temporary-code-access-enabled-text" class="positive-highlight">
            {{ "ENABLED" | translate }}
          </span>
        }
        @if (visibleFields | includes : 'temporaryCodeAccessDisabled') {
          <span id="temporary-code-access-disabled-text" class="negative-highlight">
            {{ "DISABLED" | translate }}
          </span>
        }
      </div>
    }
    <!-- Account status -->
    @if (visibleFields | some : 'accountUnlocked' : 'accountLocked') {
      <span class="item-title">{{ "LOCKED_ACCOUNT" | translate }}:</span>
      <div class="item-value">
        @if (visibleFields | includes : 'accountUnlocked') {
          <span id="account-unlocked-text" class="positive-highlight">
            {{ "ACCOUNT_UNLOCKED" | translate }}
          </span>
        }
        @if (visibleFields | includes : 'accountLocked') {
          <span id="account-locked-text" class="negative-highlight">
            {{ "ACCOUNT_LOCKED" | translate }}
          </span>
        }
      </div>
    }
    <!-- Password -->
    @if (visibleFields | includes : 'passwordChanged') {
      <span class="item-title">{{ "PASSWORD" | translate }}:</span>
      <div class="item-value">
        <span class="positive-highlight">{{ "PASSWORD_CHANGED" | translate }}</span>
      </div>
    }
  </div>
  @if (allFields.length > visibleFieldCount) {
    <div class="mt-4">
      <span id="shown-details-info">{{ ("SHOWN_ACTIVITY_DETAILS_INFO" | translate : {visibleFieldCount: visibleFieldCount}) | uppercase }}.</span>
    </div>
  }
}






